export default {
  setReportData(state, data){
    state.reportData = data;
  },
  setReportSummaryData(state, data){
    state.reportSummaryData = data;
  },

  setReportChartsData(state, data){
    state.reportChartsData = data;
  },

  setReportTotalCount(state, data){
    state.reportTotalCount = data;
  },
  setReportPaginationInfo(state, data){
    state.pageInfo = data;
  },

  setReportDataB(state, data){
    state.reportDataB = data;
  },
  setReportTotalCountB(state, data){
    state.reportTotalCountB = data;
  },
  setReportPaginationInfoB(state, data){
    state.pageInfoB = data;
  },
  setFixedColumns(state, data){
    state.fixedColumns = data;
  },
  setSummaryChartsData(state, data){
    state.summaryChartsData = data
  },
  setCurrentRowsCount(state, count){
    state.currentRowsCount = count;
  },
  setDateComparisonFields(state, data){
    state.dateComparisonFields = data;
  },
  setSorting(state, sortColumn) {
    state.sortColumn = sortColumn;
  },
  setHoverStatuses(state, statuses){
    state.hoverStatuses = statuses;
  },
  setSideBarStatus(state, status){
    state.sideBarStatus = status;
  }
}


// WEBPACK FOOTER //
// ./src/store/modules/baseReport/table/mutations.js